<template>
  <div class="components-organization-tree" :class="{hideSearch: !showSearch}">
    <div class="search-wrapper" v-if="showSearch">
      <el-input
        size="small"
        v-model="searchOrgPer"
        placeholder="请输入组织名称"
        suffix-icon="el-icon-search"
        clearable
      ></el-input>
    </div>
    <el-scrollbar class="tree-wrapper overflow-x-hidden">
      <el-tree
        ref="tree"
        :highlight-current="true"
        :data="treeData"
        :props="propsOption"
        :node-key="nodeKey"
        :expand-on-click-node="false"
        :default-expanded-keys="defaultExpandedKeys"
        :default-checked-keys="defaultCheckedKeys"
        :current-node-key="currentNodeKey"
        :show-checkbox="showCheckbox"
        @check="checkItem"
        @node-click="handleNodeClick"
        :filter-node-method="filterNode"
      >
        <div
          class="custom-tree-node"
          slot-scope="{ node,data }"
          :class="{isSelected: node.data.isSelected}"
          v-html="data.label"
        ></div>
      </el-tree>
    </el-scrollbar>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { debounce } from "@/common/js/mUtils";
export default {
  name: "organization-tree",
  props: {
    defaultTagCodes: {
      type: [Array, String],
      default: () => []
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    propsOption: {
      type: Object,
      default: () => {
        return {
          label: "name",
          children: "children",
          isLeaf: "isLeaf",
          nodeKey: "id"
        };
      }
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    nodeKey: {
      type: String,
      default: "id"
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    dataPermissions: {
      type: Boolean,
      default: false
    },
    old: {
      type: Boolean,
      default: false
    },
    positionId: {
      default: ""
    },
    // 顶部选择框是否为多选
    multiple: {
      default: false
    },
    isRole: {
      default: false
    },
    currentNodeKey: {
      default: "1088640745113845762"
    },
    enable: {
      default: false
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchFormData: {
        tagCodes: [],
        parentId: "0",
        id: 0
      },
      treeData: [],
      defaultExpandedKeys: [],
      searchOrgPer: "",
      startNum: 0
    };
  },
  computed: {
    ...mapState({
      organizationTypeList(state) {
        if (this.dataPermissions) {
          return state.dataDictionary.organizationTypeList.filter(
            item => item.name === "资金" || item.name === "明源"
          );
        } else {
          return state.dataDictionary.organizationTypeList;
        }
      }
    })
  },
  created() {
    this.searchFormData.tagCodes = this.defaultTagCodes;
    this.$api.getWholeOrgTree().then(res => {
      this.treeData = this.deepMapArr(res.body || []);
    });
    this.debounce = debounce(this.searchOrg, 500);
  },
  mounted() {
    this.$nextTick(() => {
      //取消选中
      this.$refs.tree.setCheckedKeys([]);
    });
  },
  watch: {
    defaultTagCodes: {
      handler(val) {
        if (typeof val === "string" && val && this.multiple) {
          this.searchFormData.tagCodes = val.split(",");
        } else {
          this.searchFormData.tagCodes = this.defaultTagCodes;
        }
        this.searchFormData.parentId = "0";
        this.search();
      }
    },
    tagCodes(val) {
      this.searchFormData.tagCodes = val;
      this.searchFormData.parentId = "0";
      this.search();
    },
    selectedList(newVal, oldVal) {
      // this.setTreeChecked(newVal);
    },
    treeData(newVal) {
      // this.setTreeChecked(this.selectedList);
    },
    searchOrgPer(val) {
      this.debounce();
    }
  },
  methods: {
    /**
     * 筛选组织树
     */
    searchOrg() {
      this.$refs.tree.filter(this.searchOrgPer);
    },
    /**
     * 重新搜索
     * */
    search() {
      this.searchFormData.parentId = "0";
      // this.loadNode();
      this.$emit("node-click", this.searchFormData);
    },
    /**
     * 递归遍历
     */
    deepMapArr(arr) {
      if (arr && arr.length > 0) {
        if (this.startNum == 0) {
          this.$nextTick(() => {
            this.defaultExpandedKeys = [arr[0].id];
          });
          this.startNum++;
        }
        let data = [];
        arr.forEach(el => {
          if (el.children && el.children.length > 0) {
            let item = this.deepMapArr(el.children);
            el.children = [...item];
          }
          data.push({
            id: el.id,
            label: el.name,
            children: el.children || []
          });
        });
        return data;
      }
    },
    /**
     * 设置选中
     */
    setTreeChecked(arr) {
      this.$nextTick(() => {
        this.treeData.forEach(el => {
          arr.forEach(item => {
            if (el.id == item.id) {
              this.$refs.tree.setChecked(item.id, true);
            } else {
              this.$refs.tree.setChecked(item.id, false);
            }
          });
        });
      });
    },
    /**
     * 点击节点回调
     */
    handleNodeClick(data, node, nodeDom, isDbclick) {
      if (data.isSelected) {
        return;
      }
      this.$emit("node-click", data);
    },
    cancelSelect() {
      this.$refs.tree.setCurrentKey(null);
    },
    getCheckedKeys() {
      return this.$refs.tree.getCheckedKeys();
    },
    /**
     * 节点被点击回调
     */
    checkItem(data, node) {
      if (data.parentId === 0 || data.name === "新希望集团") {
        if (node.checkedNodes.length == 0) {
          this.$emit("selectOrg", "delAll", node.checkedNodes, data); //删除全部
        } else {
          this.$emit("selectOrg", "addAll", node.checkedNodes, data); //全选增加
        }
        return;
      }
      //当前点击项是否在所有选中项集合中，若在，则为新增，若无，删除此项
      let isHave = node.checkedNodes.findIndex(el => el.id == data.id);
      if (isHave != -1) {
        //新增
        this.$emit("selectOrg", "addItem", node.checkedNodes, data);
      } else {
        //删除
        this.$emit("selectOrg", "delItem", node.checkedNodes, data);
      }
    },
    isCheked(item) {
      let sign = false;
      this.selectedList.map(inside => {
        if (item.id == inside.id) {
          sign = true;
        }
      });
      return sign;
    },
    /**
     * 筛选过滤节点
     */
    filterNode(value, data) {
      if (data.label.includes('<span style="color:#fea800">')) {
        data.label = data.label.replace('<span style="color:#fea800">', "");
        data.label = data.label.replace("</span>", "");
      }
      if (!value) return true;
      else {
        if (data.label.includes('<span style="color:#fea800">')) {
          data.label = data.label.replace('<span style="color:#fea800">', "");
          data.label = data.label.replace("</span>", "");
        }
        if (data.label.includes(value)) {
          data.label = data.label.replace(
            value,
            `<span style="color:#fea800">${value}</span>`
          );
          return true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.components-organization-tree {
  height: calc(100% - 20px);
  width: inherit;
  padding-top: 10px;

  &.hideSearch {
    padding-top: 0px;
  }
}

.search-wrapper {
  padding: 10px;
  padding-top: 0;
}

.tree-wrapper {
  height: calc(100% - 30px);
}

.search-select {
  width: 100%;
}

.isSelected {
  color: #ccc;
}
</style>